import { message } from "antd";
import { call, put, takeLatest } from "redux-saga/effects";
import api from "service/apiService";
import { ApiResponse } from "types";
import { translate } from "utils";
import { CreateHotSale, HotSale } from "../components/type";
import {
	CreateHotSaleCarsAsyncPayload,
	DeleteHotSaleAsyncPayload,
	GetListAvailableHotSaleCarsAsyncPayload,
	GetListHotSaleAsyncPayload,
	UpdateHotSaleAsyncPayload,
	UpdateOrderHotSaleAsyncPayload,
	UpdateStatusHotSaleAsyncPayload,
	changeStatusHotSale,
	createHotSaleCarsAsync,
	deleteHotSaleAsync,
	getListAvailableHotSaleCarsAsync,
	getListHotSaleAsync,
	setListHotSale,
	updateHotSaleAsync,
	updateOrderHotSaleAsync,
	updateStatusHotSaleAsync,
} from "./hot-sale.slice";
import { PayloadAction } from "@reduxjs/toolkit";

function* getLisHotSaleSaga(action: PayloadAction<GetListHotSaleAsyncPayload>) {
	// yield put({ type: setLoadingPage.type, payload: true });
	const { query, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<HotSale[]>>(
				"/dashboard/car-hot-sales",
				{
					...query,
					skip: query.skip,
				},
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		yield put({ type: setListHotSale.type, payload: response });
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetListHotSale() {
	yield takeLatest(getListHotSaleAsync, getLisHotSaleSaga);
}

function* updateStatusHotSaleSaga(
	action: PayloadAction<UpdateStatusHotSaleAsyncPayload>,
) {
	const { carId, status, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.patch(
				`/dashboard/car-hot-sales/status/${carId}`,
				{
					status,
				},
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({
			type: changeStatusHotSale.type,
			payload: {
				carId,
				status,
			},
		});
		message.success(translate("Update successful"));
		callback && callback();
	} else {
		message.error(translate(error.message));
	}
}

function* watchUpdateStatusHotSale() {
	yield takeLatest(updateStatusHotSaleAsync, updateStatusHotSaleSaga);
}

function* updateOrderHotSaleSaga(
	action: PayloadAction<UpdateOrderHotSaleAsyncPayload>,
) {
	const { carId, newOrder } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.patch(
				`/dashboard/car-hot-sales/order/${carId}`,
				{
					order: newOrder,
				},
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		message.success(translate("Update successful"));
	} else {
		message.error(translate(error.message));
	}
}

function* watchUpdateOrderHotSale() {
	yield takeLatest(updateOrderHotSaleAsync, updateOrderHotSaleSaga);
}

function* deleteHotSaleSaga(action: PayloadAction<DeleteHotSaleAsyncPayload>) {
	const { carId, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.delete(
				`/dashboard/car-hot-sales/${carId}`,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		message.success(translate("Delete successful"));
		callback && callback();
	} else {
		message.error(translate(error.message));
	}
}

function* watchDeleteHotSale() {
	yield takeLatest(deleteHotSaleAsync, deleteHotSaleSaga);
}

function* getListAvailableHotSaleCarsSaga(
	action: PayloadAction<GetListAvailableHotSaleCarsAsyncPayload>,
) {
	const { query, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<CreateHotSale>>(
				"/dashboard/cars/hot-sale-available",
				query,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback(response);
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetListAvailableHotSaleCars() {
	yield takeLatest(
		getListAvailableHotSaleCarsAsync,
		getListAvailableHotSaleCarsSaga,
	);
}

function* createHotSaleCarsSaga(
	action: PayloadAction<CreateHotSaleCarsAsyncPayload>,
) {
	const { hotSales, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.post("/dashboard/car-hot-sales", {
				data: hotSales,
			});
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		message.success(translate("Create successful"));
		callback && callback();
	} else {
		message.error(translate(error.message));
	}
}

function* watchCreateHotSaleCars() {
	yield takeLatest(createHotSaleCarsAsync, createHotSaleCarsSaga);
}

function* updateHotSaleSage(
	action: PayloadAction<UpdateHotSaleAsyncPayload>
) {
	const { startDate, endDate, carId } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.patch(
				`/dashboard/car-hot-sales/${carId}`,
				{
					startDate,
          endDate,
				},
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		message.success(translate("Update successful"));
	} else {
		message.error(translate(error.message));
	}
}

function* watchUpdateHotSale() {
	yield takeLatest(updateHotSaleAsync, updateHotSaleSage);
}

const hotSaleSaga = [
	watchGetListHotSale(),
	watchUpdateStatusHotSale(),
	watchDeleteHotSale(),
	watchGetListAvailableHotSaleCars(),
	watchCreateHotSaleCars(),
	watchUpdateOrderHotSale(),
	watchUpdateHotSale(),
];

export default hotSaleSaga;
